import { render, staticRenderFns } from "./WizardIntroStep.vue?vue&type=template&id=b1a224aa&scoped=true"
import script from "./WizardIntroStep.vue?vue&type=script&lang=js"
export * from "./WizardIntroStep.vue?vue&type=script&lang=js"
import style0 from "./WizardIntroStep.vue?vue&type=style&index=0&id=b1a224aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a224aa",
  null
  
)

export default component.exports